import React from 'react';
import Skeleton from 'react-loading-skeleton';

const DarkSkeleton = (props) => {
    return (
        <Skeleton
            {...props}
            baseColor="var(--skeleton-base-color)"
            highlightColor="var(--skeleton-highlight-color)"
        />
    );
};

export default DarkSkeleton;